module.exports = __webpack_public_path__ + "static/pattern-green@2x-cfb321693cebb1fec31905a2ebde309f.png";